import React, { useState } from "react";
import "../../shop.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import img1 from "../../sliderImg/slider1.avif";
import img2 from "../../sliderImg/slider2.avif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {
  setActiveCategory,
  setSortingOrder,
} from "../../../../ReduxStore/Actions/mainAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
function InitialOfferSection() {
  const [activecat, setActiveCat] = useState("All Products");

  const dispatch = useDispatch();

  const data = useSelector((store) => store.products);

  function setActiveCat2(val) {
    setActiveCat(val);

    setActiveCategory(val, dispatch);
  }

  function handlesortChange(e) {
    setSortingOrder(e.target.value, dispatch);
  }

  return (
    <>
      <div className="shop_outer">
        <p className="location">
          {" "}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>
            Shop <FontAwesomeIcon icon={faAngleRight} />
          </b>
          &nbsp; All Products
        </p>

        <div className="slider_Section_shop">
          <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
            <SwiperSlide>
              <img src={img2} alt="Not Found" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={img1} alt="Not Found" />
            </SwiperSlide>
          </Swiper>
        </div>
        <div className="shop_heading">
          <h1>Visit the Store To Explore Our All Products</h1>
          <p>
            Our products play a key role during early life. From supporting
            healthy growth and development to providing the medical nutrition
            necessary when health is{" "}
          </p>
        </div>
      </div>
    </>
  );
}

export default InitialOfferSection;
